// extracted by mini-css-extract-plugin
module.exports = {"valueInput":"styles_valueInput__1IC3X","timeWrapper":"styles_timeWrapper__1qN1Q","timetext":"styles_timetext__21h2L","tooltipContent":"styles_tooltipContent__c_nK0"};